import { useQuery } from '@tanstack/react-query';
import useExpress from '../../../../../repository/react-query/useExpress';

const getGlobalSearchByLTQuery = (ltNumber) =>
    useExpress({
        endpoint: '/search/lt-number', // wrap
        params: { where: { lt_number: ltNumber } },
    });

const useGlobalSearchByLTQuery = ({ enabled = true, key = 'global-search-results', ltNumber = '' } = {}) => {
    const queryFn = getGlobalSearchByLTQuery(ltNumber);
    const queryKey = [key, { ltNumber }];
    return useQuery({ queryKey, queryFn, enabled });
};

export default useGlobalSearchByLTQuery;
